import { useState, useEffect } from "react";
import { Form, Button, Dropdown } from "react-bootstrap";
import { Funnel } from "react-bootstrap-icons";

export default function EventFilters({
  dateFilter,
  setDateFiter,
  sportFilter,
  setSportFilter,
  statusFilter,
  setStatusFilter,
  clusterFilter,
  setClusterFilter,
  venueFilter,
  setVenueFilter,
  feeType,
  setFeeType,
  applyFilters,
  resetFilters,
}) {
  const [clusters, setClusters] = useState([]);
  const [venues, setVenues] = useState([]);
  const [show, setShow] = useState(false);

  const fetchVenuesByCluster = async (clusterId) => {
    try {
      const token = localStorage.getItem("access_token_admin");

      const res = await fetch(
        `${process.env.REACT_APP_TICKET_URL}/api/v1/common/combined-events-dropdown?cluster_id=${clusterId}`,
        {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `${token}`,
          },
        },
      );

      const result = await res.json();

      setVenues(result?.data?.venue || []);
    } catch (error) {
      console.error("Venue fetch error:", error);
    }
  };

  useEffect(() => {
    const fetchDropdownData = async () => {
      try {
        const token = localStorage.getItem("access_token_admin");

        const res = await fetch(
          `${process.env.REACT_APP_TICKET_URL}/api/v1/common/combined-events-dropdown`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `${token}`,
            },
          },
        );

        const result = await res.json();

        setClusters(result?.data?.cluster || []);
        // ❌ remove this:
        // setVenues(result?.data?.venue || []);
      } catch (error) {
        console.error("Dropdown fetch error:", error);
      }
    };

    fetchDropdownData();
  }, []);

  return (
    <Dropdown align="end" show={show} onToggle={(isOpen) => setShow(isOpen)}>
      <Dropdown.Toggle
        variant="light"
        className="d-flex align-items-center border bg-white"
        style={{ paddingTop: "15px" }}
        id="filter-dropdown"
      >
        <Funnel size={16} className="me-1 text-muted" />
        Filter
      </Dropdown.Toggle>

      <Dropdown.Menu
        style={{
          width: "280px",
          padding: "15px",
          maxHeight: "70vh", // 👈 limits height based on screen
          overflowY: "auto", // 👈 enables vertical scroll
        }}
      >
        <Form>
          <Form.Group className="mb-3">
            <Form.Label>Event Type</Form.Label>
            <Form.Select
              value={sportFilter}
              onChange={(e) => setSportFilter(e.target.value)}
            >
              <option value="">Select Event Type</option>
              <option value="sports">Sports</option>
              <option value="others">Other</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Date</Form.Label>
            <Form.Control
              type="date"
              value={dateFilter}
              onChange={(e) => setDateFiter(e.target.value)}
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Status</Form.Label>
            <Form.Select
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <option value="">Select Status</option>
              <option value="true">Active</option>
              <option value="false">Inactive</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Fee Type</Form.Label>
            <Form.Select
              value={feeType}
              onChange={(e) => setFeeType(e.target.value)}
            >
              <option value="">Select Fee Type</option>
              <option value="free">Free</option>
              <option value="paid">Paid</option>
            </Form.Select>
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>Cluster</Form.Label>
            <Form.Select
              value={clusterFilter}
              onChange={(e) => {
                const selectedClusterId = e.target.value;

                setClusterFilter(selectedClusterId); // ✅ save cluster_id
                setVenueFilter(""); // ✅ reset venue
                fetchVenuesByCluster(selectedClusterId); // ✅ fetch new venues
              }}
            >
              <option value="">Select Cluster</option>

              {clusters.map((cluster) => (
                <option key={cluster.id} value={cluster.id}>
                  {cluster.cluster_name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Venue</Form.Label>
            <Form.Select
              value={venueFilter}
              disabled={!clusterFilter}
              onChange={(e) => setVenueFilter(e.target.value)}
            >
              <option value="">Select Venue</option>

              {venues.map((venue) => (
                <option key={venue.id} value={venue.id}>
                  {venue.venue_name}
                </option>
              ))}
            </Form.Select>
          </Form.Group>

          <div className="d-flex gap-2">
            <Button
              size="sm"
              variant="primary"
              onClick={(e) => {
                e.preventDefault();
                applyFilters();
                setShow(false);
              
              }}
            >
              Apply
            </Button>
            <Button
              size="sm"
              variant="light"
              onClick={(e) => {
                e.preventDefault();
                resetFilters();

                setShow(false);
              }}
            >
              Reset
            </Button>
          </div>
        </Form>
      </Dropdown.Menu>
    </Dropdown>
  );
}
